import React from "react";
import LocationData from "../../data/contact/LocationData.json";

const allData = LocationData;

const ContactLocation = () => {
  return (
    <>
      {/* {allData.slice(0,2).map((data, index) => (
                <div className="col-lg-4 col-sm-6" key={index}>
                    <div className="office-location">
                        <div className="thumbnail">
                            <img src={process.env.PUBLIC_URL + data.thumb} alt="Office" />
                        </div>
                        
                    </div>
                </div>
            ))} */}
      {/* Add iframe here */}
      <div
        className="container"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <iframe
          title="UCWF Facilities Management Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.4740495174415!2d55.25888017605416!3d25.187231132103044!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6932814763f9%3A0x8903b459bc782a09!2sUCWF%20Facilities%20Management%20Services%20LLC!5e0!3m2!1sen!2sus!4v1736840713943!5m2!1sen!2sus"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </>
  );
};

export default ContactLocation;
